module.exports = __webpack_public_path__ + "assets/img/activity-time-ea9bb485.png";